import gql from 'graphql-tag';

const GraphQL = {
  Query: {
    PUBLIC_GROUPS: gql`
      query PublicGroups {
        publicGroups {
          groupkey
          title
          autojoin
          nodelete
          public
          joined
          purchased
          assets {
            amount
            description
            media
            code
          }
        }
      }
    `,
    LIST_USER_MEMBERSHIPS: gql`
      query ListUserMemberships($userkey: Int!, $dataCentric: DataCentric) {
        listUserMemberships(userkey: $userkey, dataCentric: $dataCentric) {
          groupkey
          title
          access
          userkey
          firstname
          lastname
          permissions {
            rights
            list
            member
            content
            report
            assess
            discuss
          }
          role
        }
      }
    `,
    ORGANIZATION_LIST_USERS: gql`
      query OrganizationListUsers($userkey: Int!) {
        organizationListUsers(userkey: $userkey) {
          userkey
          firstname
          lastname
          username
        }
      }
    `,
    LIST_ALL_COURSES_PATHWAYS: gql`
      query ListAllCoursesPathways {
        listAllCoursesPathways {
          pathkey
          pathname
          type
        }
      }
    `,
    LIST_ALL_GROUPS_WITHIN_DOMAIN: gql`
      query ListAllGroupsWithinDomain {
        listAllGroupsWithinDomain {
          groupkey
          domainkey
          title
          created
          autojoin
          nodelete
          public
          assets {
            amount
            description
            media
            code
          }
        }
      }
    `,
    LIST_GROUPS_BY_COURSE_OR_PATHKEY: gql`
      query ListGroupsByCourseOrPathkey(
        $type: ContentType
        $contentkey: String
      ) {
        listGroupsByCourseOrPathkey(type: $type, contentkey: $contentkey) {
          groupkey
          domainkey
          title
        }
      }
    `,
    LIST_ALL_DOMAIN_COLLECTIONS: gql`
      query ListAllDomainCollections {
        listAllDomainCollections {
          collectionkey
          title
          description
          created
        }
      }
    `,
    LIST_GROUPS_BY_COLLECTIONKEY: gql`
      query ListGroupsByCollectionkey($collectionkey: Int!) {
        listGroupsByCollectionkey(collectionkey: $collectionkey) {
          groupkey
          domainkey
          title
        }
      }
    `
  },
  Mutation: {
    /** Join a *public* group. */
    JOIN_GROUP: gql`
      mutation JoinGroup($joinGroupParams: JoinGroupParams!) {
        joinGroup(joinGroupParams: $joinGroupParams) {
          groupkey
          userkey
        }
      }
    `,
    JOIN_GROUP_BY_CODE: gql`
      mutation JoinGroupByCode($joinGroupByCodeParams: JoinGroupByCodeParams!) {
        joinGroupByCode(joinGroupByCodeParams: $joinGroupByCodeParams) {
          groupkey
          userkey
        }
      }
    `,
    CREATE_GROUP_MEMBER: gql`
      mutation CreateGroupMember(
        $userkey: Int!
        $groupkey: Int!
        $access: Int!
      ) {
        createGroupMember(
          userkey: $userkey
          groupkey: $groupkey
          access: $access
        ) {
          groupkey
          userkey
          username
          created
          access
          title
          permissions {
            rights
            list
            member
            content
            report
            assess
            discuss
          }
          role
          firstname
          lastname
          selectable
          selected
          added
        }
      }
    `,
    DELETE_GROUP_MEMBER: gql`
      mutation DeleteGroupMember($userkey: Int!, $groupkey: Int!) {
        deleteGroupMember(userkey: $userkey, groupkey: $groupkey)
      }
    `,
    CREATE_GROUP_COURSE_RELATIONSHIP: gql`
      mutation CreateGroupCourseRelationship($group: UserGroupContentParam) {
        createGroupCourseRelationship(group: $group)
      }
    `
  }
};

export default GraphQL;
